import type {
  RecommendationResponse,
  ResultsCategory,
  ResultsRecommendationResponse,
} from './types';

type RawResultsResponse = {
  offers: RecommendationResponse['offers'];
  categories: { id: ResultsCategory['id']; offerIds: string[] }[];
};

export function joinCategoriesToOffers(raw: RawResultsResponse): ResultsRecommendationResponse {
  return {
    categories: raw.categories.map(
      (category): ResultsCategory => ({
        ...category,
        offers: raw.offers
          .filter(({ offer }) => category.offerIds.includes(offer.id))
          .map(({ offer }) => offer),
      }),
    ),
  };
}
